import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrcamentosEPacotesDetalharComponent } from './orcamentos-e-pacotes-detalhar.component';


@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: OrcamentosEPacotesDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class OrcamentosEPacotesDetalharRoutingModule { }
